import { AjaxError } from '@api';
import { headers } from '@api';

/**
 * Gets the occasions from the white label api
 *
 * @param rootData
 * @param filters
 * @returns {Promise<object>}
 */
const searchApi = async (rootData, filters) => {
    const url = rootData.baseUrl + `/app/plugins/occasion-picker/faster-search.php`;
    const id = rootData.postId !== undefined ? rootData.postId : 0;

    const response = await fetch(url, {
        headers,
        body: JSON.stringify({
            id,
            filters
        }),
        method: 'POST',
        mode: 'cors'
    });

    if (!response.ok || (response.status !== 200 && response.status !== 201)) {
        throw new AjaxError(`Post entry to ${url} has failed`, response);
    }

    return await response.json();
};

/**
 * Gets the brandModels from the white label api
 *
 * @param rootData
 * @returns {Promise<object>}
 */
const getBrandModelsApi = async rootData => {
    const url = rootData.baseUrl + `/wp-json/occasion-picker/v1/brandmodels`;

    const response = await fetch(url, {
        headers,
        method: 'GET',
        mode: 'cors'
    });

    if (!response.ok || (response.status !== 200 && response.status !== 201)) {
        throw new AjaxError(`Get to ${url} has failed`, response);
    }

    return await response.json();
};

export { searchApi, getBrandModelsApi };
